import { React, useState, useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap";
import { } from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./login.css";
import { Redirect, Link, useHistory } from "react-router-dom";
import httpService from "../../services/http.service";
import loginImg from "../../assets/loginleft.png";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../common/loader";
import ErrorMessage from "../common/errorMsg";
import SuccessMessage from "../common/successMsg";
import { encryptText } from "./encryptanddecrypted/encryptAndDecrypt";
import WarningMessage from "../common/warnMsg";
import PlanOnBoard from "../dashboard/cloudDashboard/plans-onboard/planOnBoard";

let CreateAccountPage = (props) => {
  const history = useHistory();
  const [formData, setFormData] = useState({
    phone: "",
    username: "",
    userEmail: "",
    password: "",
    isPropertyManager: false
  });



  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false)
  const [userId, setUserId] = useState()
  const resetForm = () => {
    setFormData({
      phone: "",
      username: "",
      userEmail: "",
      password: "",
    });
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  function validateEmail(email) {
    // console.log(email,"email")
    // Regular expression for a basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Test the email against the regex
    return emailRegex.test(email);
  }

  const onFormSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username) {
      WarningMessage("Please enter the Account Name");
      return;
    }

    if (!formData.userEmail) {
      WarningMessage("Please Enter the email address");
      return;
    }

    if (!validateEmail(formData.userEmail)) {
      WarningMessage("Please give vaild email address");
      return;
    }

    if (!formData.password) {
      WarningMessage("Please enter the password");
      return;
    }

    if (!formData.phone) {
      WarningMessage("Please enter the phone number");
      return;
    }

    if (formData.phone.length !== 10) {
      WarningMessage("Please enter valid phone number");
      return;
    }

    try {

      setLoading(true);
      let data = {
        UserName: formData.username,
        email: formData.userEmail,
        Password: formData.password,
        type: formData.isPropertyManager ? "property_manager" : "clouduser",
        Phone: formData.phone
      };

      console.log(data, "Data is")

      let response = await httpService.CreateUpdate("checkuser", data)

      if (response.data.ack === "0") {
        WarningMessage(response.data.message)
        return
      }

      if (response.data.ack === "1") {
        setUserId(response.data.data.userId)
        console.log("From server response :", response.data.data.userId)
        setShow(true)
      }
    } catch (error) {
      ErrorMessage("Something went wrong")
    }
    finally {
      setLoading(false)
    }


  };
  return (
    <div>
      <div className="home-btn d-none d-sm-block">
        <i className="bx bx-home h2"></i>
      </div>
      <div className="account-pages">
        {show ? <PlanOnBoard show={show} userId={userId} setShow={setShow} data={formData} /> : <Container>
          <Row className="justify-content-center">
            <Col md={12} lg={11} xl={8}>
              <Card className="overflow-hidden login-wrapper">
                <CardBody className="row">
                  <div className="col-6 p-0">
                    <div className="login-img">
                      <img src={loginImg} alt="LoginImage" />
                    </div>
                  </div>
                  <div className="col-6 p-0">
                    <div className="login-right">
                      <div className="login-txthead">Cloud User Register</div>
                      <p className="signText">Sign Up to continue to RSD.</p>
                      <div className="">
                        <form
                          className="form-horizontal login-form"
                          onSubmit={onFormSubmit}
                        >
                          <div className="form-group">
                            <span className="input-icon">
                              <i className="fa fa-user"></i>
                            </span>
                            <input
                              name="username"
                              className="form-control formInput"
                              placeholder="Account Name"
                              type="text"
                              value={formData.username}
                              onChange={(e) => {
                                const regex = /^[a-zA-Z0-9_ ]*$/
                                const { value } = e.target

                                if (regex.test(value)) {
                                  handleChange(e)
                                }
                              }}
                            // validate={{
                            //   required: {
                            //     value: true,
                            //     errorMessage: "Required",
                            //   },
                            // }}
                            />
                          </div>
                          <div className="form-group">
                            <span className="input-icon">
                              <i className="fa fa-envelope"></i>
                            </span>
                            <input
                              name="userEmail"
                              className="form-control formInput"
                              placeholder="Email Address"
                              type="email"
                              value={formData.userEmail}
                              onChange={handleChange}

                            // validate={{
                            // required: {
                            // value: true,
                            // errorMessage: "Required",
                            // },
                            // }}
                            />
                          </div>
                          <div className="form-group">
                            <span className="input-icon">
                              <i className="fa fa-lock"></i>
                            </span>
                            <input
                              name="password"
                              type="password"
                              className="form-control formInput"
                              placeholder="Password"
                              value={formData.password}
                              onChange={handleChange}
                            // validate={{
                            //   required: {
                            //     value: true,
                            //     errorMessage: "Required",
                            //   },
                            // }}
                            />
                          </div>
                          <div className="form-group">
                            <span className="input-icon">
                              <i class="fa fa-phone"></i>
                            </span>
                            <input
                              name="phone"
                              value={formData.phone}
                              onChange={(e) => {
                                const { value } = e.target;
                                const regex = /^[0-9]*$/

                                if (regex.test(value)) {
                                  handleChange(e)
                                }
                              }}
                              className="form-control formInput"
                              type="text"
                              maxLength="10"
                              placeholder="Mobile Number"
                            />
                          </div>
                          <div className="form-group" style={{ display: "flex", gap: 3 }}>
                            <input
                              name="isPropertyManager"
                              type="checkbox"
                              checked={formData.isPropertyManager}
                              onClick={handleChange}
                              style={{ cursor: "pointer" }}
                            />
                            <p>Property Manager</p>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 2,
                              marginTop: 10,
                            }}
                          >
                            <div className="" style={{ width: "100%" }}>
                              <button
                                className="btn btn-primary"
                                type="submit"
                                disabled={loading}
                              >
                                Sign Up
                              </button>
                            </div>

                            {loading ? null : (
                              <>
                                <div style={{ fontSize: 17 }}>OR</div>
                                <div className="" style={{ width: "100%" }}>
                                  <div
                                    className="btn btn-primary"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      history.push("/");
                                    }}
                                  >
                                    Log In
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>}
      </div>
    </div>

  );
};

export default CreateAccountPage;
